<template>
  <v-layout wrap row class="createaccount--account">
    <v-flex xs12>
      <TextInputCommon
        v-model="value.username"
        :disabled="disabled"
        :validations="inputValidations.userName"
        display-name="Username"
        identifier="username" />
      <span v-if="hasUsernameErrors" class="createaccount--username-help">
        {{accountDescription}}
      </span>
    </v-flex>

    <v-flex sm12>
      <PasswordValidationField
        v-model="value.password"
        :disabled="disabled"
        :hide-details="true"
        autocomplete="new-password"
        data-vv-name="Password"
        label="Password"
        name="password"
        outline
        @validation="setPasswordError" />
    </v-flex>

    <v-flex sm12>
      <PasswordField
        v-model="value.passwordConfirm"
        v-validate="{...inputValidations.password, required: true, confirmed: value.password}"
        :disabled="disabled"
        :error-messages="errors.collect('confirm')"
        :hide-details="true"
        autocomplete="new-password"
        data-vv-name="Confirm Password"
        label="Confirm Password"
        name="confirm"
        outline />
    </v-flex>
  </v-layout>
</template>

<script>
import { Components, Constants } from '@spectorasoftware/homegauge-vue';

import TextInputCommon from '@/components/common/TextInputCommon.vue';

const { PasswordField, PasswordValidationField } = Components;
const { InputValidations } = Constants;

const ACCOUNT_DESCRIPTION = 'Username must be at least 3 characters and cannot have spaces or special characters other than "@_.-"';
export default {
  components: {
    PasswordField,
    PasswordValidationField,
    TextInputCommon,
  },
  inject: ['$validator'],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      accountDescription: ACCOUNT_DESCRIPTION,
      inputValidations: InputValidations,
    };
  },
  computed: {
    hasUsernameErrors() {
      return this.errors.collect('Username').length > 0;
    },
  },
  methods: {
    setPasswordError(error) {
      this.$emit('setPasswordError', error);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/vars/typography";

.createaccount {
  &--poweredby {
    > p {
      font-size: 1.143rem;
      line-height: 1.63;
    }

    .powered-by-header {
      background: #f3f3f3;
      border: 1px solid #f1f6fb;
      border-radius: 4px;
      margin: 0 0 1.2rem;
    }
  }

  &--username {
    &-help {
      display: block;
      font-size: 0.85rem;
      font-style: italic;
      padding: 10px;
    }
  }
}
</style>
